import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

type Store = {
  isSignatureDigital: boolean
  setIsSignatureDigital: (value: boolean) => void
  isFirstReceiptPaid: boolean
  setIsFirstReceiptPaid: (value: boolean) => void
}

export const usePaymentConfirmationStore = create<Store>()(
  devtools(
    (set) => ({
      isSignatureDigital: true,
      setIsSignatureDigital: (isSignatureDigital) =>
        set({ isSignatureDigital }),
      isFirstReceiptPaid: false,
      setIsFirstReceiptPaid: (isFirstReceiptPaid) =>
        set({ isFirstReceiptPaid }),
    }),
    { name: 'PaymentConfirmationStore' },
  ),
)
